import { FundTrackerFilterUseCaseRedirect } from "@mais-retorno-front/core-business/useCases/fund-tracker/fund-tracker-filter-redirect.usecase";

interface IMakeFundTrackerFilterRedirectUseCaseProps {
  userIsPremium: boolean;
}

export const makeFundTrackerFilterRedirectUseCase = ({ userIsPremium }: IMakeFundTrackerFilterRedirectUseCaseProps) => {
  return new FundTrackerFilterUseCaseRedirect(userIsPremium);
}